import { useState, useEffect, forwardRef } from 'react';

import {
    Layout as PropsLayout,
    Selector as PropsSelector,
} from '@/models/Props';

import { ImgLazy, Link } from '@/components/blocks';
import { LGridSystem } from '@/components/layouts';

import './Container.scss';

interface PropsContainer extends PropsLayout, PropsSelector {
    company?: string;
    href?: string;
}

const Container = forwardRef(
    ({ children, className, dataAttb, company, href }: PropsContainer, ref) => {
        const [companyAsset, setCompanyAsset] = useState(null);

        const getAsset = async () => {
            const img = await import(`../../../assets/img/${company}-logo.png`);

            setCompanyAsset(img.default);
        };

        useEffect(() => {
            if (company) {
                getAsset();
            }
        });

        return (
            <LGridSystem
                ref={ref}
                dataAttb={dataAttb}
                className={'container' + (className ? ` ${className}` : '')}
                sortChildren={'rows'}
                positioning={{ justifyItems: 'center' }}
                gap={1.25}
            >
                {companyAsset ? (
                    <Link href={href} dataAttb={{ 'data-brand': 'company' }}>
                        <ImgLazy
                            width={8}
                            src={companyAsset}
                            alt={`${company} logo`}
                        />
                    </Link>
                ) : null}

                {children}
            </LGridSystem>
        );
    }
);

export default Container;
